import { common_utils } from "../../../../../../common/common_utils";
import { useQueryParams } from "./use_query_params";

export function useTemplateId() {
	const { template_id } = useQueryParams<{ template_id?: string }>();

	let type: common_utils.TemplateQueryParamType, id: string;
	if (template_id) {
		[type, id] = template_id.split("_") as [
			common_utils.TemplateQueryParamType,
			string
		];

		return [template_id, type, id] as const;
	}

	return [undefined, undefined, undefined] as const;
}
